export default __webpack_public_path__ + "static/media/thunderstorm-night.28732f58.svg";